<!-- 星座分析问卷 -->
<template>
  <div class="result">
    <div class="container">
      <img
        class="bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e8c98e00099ee5d7823b2d86ed2dba44.png"
        alt=""
      />
      <div v-if="info">
        <div class="c-item top">
          <div class="user-info">
            <div class="avatar" v-if="info.head_img">
              <img class="avatar-image" :src="info.head_img" alt="" />
            </div>
            <div class="nickname">{{
              info.truename || info.nickname || ''
            }}</div>
          </div>
          <img
            class="status-image"
            :src="imageData[info.starSignInfo.id].image"
            alt=""
          />
          <div class="c-title">
            <img
              class="title-icon"
              :src="imageData[info.starSignInfo.id].icon"
              alt=""
            />
            <div class="title-text">星座分析</div>
          </div>
          <div class="feature">
            <div
              class="feature-item"
              :class="{ 'feature-text': index == 0 }"
              v-for="(item, index) in info.queResult"
              :key="index"
              v-html="item"
            ></div>
          </div>
          <div class="c-title">
            <img
              class="title-icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ac054aaec63ef8616db864f178e9e879.png"
              alt=""
            />
            <div class="title-text"
              >{{ info.starSignInfo.title }}减肥最优解</div
            >
          </div>
          <div class="f-text" v-html="info.starSignInfo.weight_solution"></div>
        </div>
        <div class="c-item course-container">
          <div class="course-box">
            <div class="course-content">
              <img
                class="dot"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/85f7f551417e6d5b3943a997105a1147.png"
                alt=""
              />
              <div class="c-desc" v-html="info.recommend_title"></div>
            </div>
          </div>
          <div class="free" @click="bindFree" v-if="info.isShow"
            >体验一日营养师饮食指导</div
          >
          <div class="more" @click="bindMore">更多问卷</div>
        </div>
        <img
          class="logo"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getShareUrl } from '../../common.js'
import { imageData } from './data'
import appApi from '@/common/app-common.js'
export default {
  data() {
    return {
      info: null,
      imageData: imageData,
      gender: {
        1: 'man_body_icon',
        2: 'woman_body_icon'
      }
    }
  },
  created() {
    this.getResult()
  },
  methods: {
    getResult() {
      let params = {
        que_user_id: this.$route.query.que_id,
        admin_uid: this.$route.query.admin_uid,
        que_id: this.$route.query.que_type
      }
      this.$http
        .getBaseAppWithHeader('que/QueBase/getQueResult', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.queResult.splice(0, 0, res.data.starSignInfo.introduce)
            res.data.queResult.splice(
              2,
              0,
              res.data.starSignInfo.third_sentence
            )
            res.data.queResult.splice(5, 0, res.data.starSignInfo.six_sentence)
            this.info = res.data
            this.$emit('copyUrl', getShareUrl(this.info.que_id))
          } else {
            this.$toast(res.msg)
          }
        })
    },
    bindFree() {
      if (this.$http._isApp()) {
        this.$betterwe.jumpRoute(
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Ff960ae672d88a771b0e26e06201169bb.png'
        )
      } else {
        this.$toast('请在app内打开')
      }
    },
    bindMore() {
      this.$router.push('/common-questions/home')
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  min-height: 100vh;
  background-color: #f7f7f7;

  .container {
    min-height: 60vh;
    position: relative;
    background-image: linear-gradient(
      180deg,
      rgba(255, 174, 194, 1) 0px,
      rgba(255, 174, 194, 0) 350px
    );
    padding: 56px 16px 30px;
    box-sizing: border-box;
  }

  .bg {
    position: absolute;
    right: 30px;
    top: 10px;
    width: 121px;
    height: 109px;
    object-fit: contain;
  }

  .c-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .c-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .title-icon {
      width: 26px;
      height: 26px;
      object-fit: contain;
      margin-right: 6px;
    }

    .title-text {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #27243c;
      line-height: 28px;
    }
  }

  .top {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .user-info {
      width: 100%;
      margin-top: -47px;
      text-align: center;
      margin-bottom: 10px;

      .avatar {
        margin: 0 auto;
        width: 54px;
        height: 54px;
        border: 2.5px solid #fff;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 6px;
        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 22px;
      }
    }

    .status-image {
      width: 100%;
      margin-bottom: 10px;
    }

    .feature {
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 20px;
      color: rgba(39, 36, 60, 0.45);

      .bold {
        color: rgba(254, 122, 150, 1);
      }

      .feature-item {
        margin-bottom: 16px;
      }

      .feature-text {
        color: #27243c;
      }
    }

    .f-text {
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #27243c;
      line-height: 23px;

      .bold {
        color: rgba(50, 205, 97, 1);
      }
    }
  }

  .course-container {
    padding-top: 34px;

    .course-box {
      position: relative;
      margin-bottom: 16px;
      width: 100%;

      .course-content {
        padding: 16px;
        box-sizing: border-box;
        border-radius: 6px;
        background: rgb(255, 241, 244);
        position: relative;
        z-index: 1;

        .dot {
          width: 40px;
          height: 40px;
          position: absolute;
          left: 14px;
          top: 0;
          transform: translate(0%, -50%);
        }

        .c-flex {
          display: flex;
          align-items: flex-end;
          margin-bottom: 2px;

          .c-flex-left {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            font-size: 11px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #73689d;
            line-height: 20px;
          }

          .c-avatar {
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin-left: 20px;
          }
        }

        .c-desc {
          font-size: 15px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #27243c;
          line-height: 24px;
        }
      }
    }

    .course-box::after {
      content: '';
      position: absolute;
      z-index: 0;
      width: 0px;
      height: 0px;
      right: 50px;
      bottom: -10px;
      border-left: 20px solid rgb(255, 241, 244);
      border-bottom: 10px solid transparent;
      border-top: 10px solid transparent;
    }

    .free {
      text-align: center;
      height: 40px;
      background: linear-gradient(180deg, #ff9bbc 0%, #fe7a96 100%);
      border-radius: 20px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 40px;
      margin-bottom: 12px;
    }

    .more {
      text-align: center;
      height: 40px;
      border-radius: 20px;
      box-sizing: border-box;
      border: 1px solid rgba(82, 68, 133, 0.3);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #524485;
      line-height: 40px;
    }
  }
}

.logo {
  height: 12px;
  margin: 20px auto 0px;
}

.share {
  font-size: 24px;
}
</style>
